
import { type CaixaLotteryType, type ClosureType, CAIXA_LOTTERIES } from "./index";

// Função para gerar números aleatórios únicos dentro de um range
const generateRandomNumbers = (min: number, max: number, count: number): number[] => {
  const numbers: number[] = [];
  while (numbers.length < count) {
    const num = Math.floor(Math.random() * (max - min + 1)) + min;
    if (!numbers.includes(num)) {
      numbers.push(num);
    }
  }
  return numbers.sort((a, b) => a - b);
};

// Função para gerar jogos baseados em fechamento
export const generateClosureGames = (
  lotteryType: CaixaLotteryType,
  closure: ClosureType,
  fixedNumbers?: number[]
): Array<{ numbers: string[] }> => {
  const lottery = CAIXA_LOTTERIES[lotteryType];
  const games: Array<{ numbers: string[] }> = [];
  
  // Determinar o range de números da loteria
  let minNum = 1;
  let maxNum = 60;
  
  switch (lotteryType) {
    case "mega-sena":
      maxNum = 60;
      break;
    case "quina":
      maxNum = 80;
      break;
    case "lotofacil":
      maxNum = 25;
      break;
    case "dupla-sena":
      maxNum = 50;
      break;
    case "lotomania":
      minNum = 0;
      maxNum = 99;
      break;
    case "dia-de-sorte":
      maxNum = 31;
      break;
  }

  // Gerar o pool de números base
  let baseNumbers: number[] = [];
  
  if (fixedNumbers && fixedNumbers.length > 0) {
    baseNumbers = [...fixedNumbers];
    // Completar com números aleatórios até atingir o total necessário
    const remainingCount = closure.totalNumbers - fixedNumbers.length;
    if (remainingCount > 0) {
      const availableNumbers = Array.from(
        { length: maxNum - minNum + 1 }, 
        (_, i) => i + minNum
      ).filter(num => !fixedNumbers.includes(num));
      
      for (let i = 0; i < remainingCount; i++) {
        const randomIndex = Math.floor(Math.random() * availableNumbers.length);
        baseNumbers.push(availableNumbers.splice(randomIndex, 1)[0]);
      }
    }
  } else {
    // Gerar pool de números totalmente aleatório
    baseNumbers = generateRandomNumbers(minNum, maxNum, closure.totalNumbers);
  }

  // Gerar os jogos usando diferentes combinações do pool
  for (let i = 0; i < closure.gamesGenerated; i++) {
    let gameNumbers: number[] = [];
    
    if (lotteryType === "lotomania") {
      // Para Lotomania, sempre 50 números
      gameNumbers = generateRandomNumbers(0, 99, 50);
    } else {
      // Para outras loterias, usar combinações do pool base
      const numbersNeeded = lottery.drawNumbers;
      
      if (fixedNumbers && fixedNumbers.length > 0) {
        // Garantir que os números fixos estejam sempre presentes
        gameNumbers = [...fixedNumbers];
        const remaining = numbersNeeded - fixedNumbers.length;
        
        if (remaining > 0) {
          const availableFromPool = baseNumbers.filter(num => !fixedNumbers.includes(num));
          // Selecionar aleatoriamente do pool restante
          for (let j = 0; j < remaining && j < availableFromPool.length; j++) {
            const randomIndex = Math.floor(Math.random() * availableFromPool.length);
            const selectedNum = availableFromPool.splice(randomIndex, 1)[0];
            if (!gameNumbers.includes(selectedNum)) {
              gameNumbers.push(selectedNum);
            }
          }
        }
      } else {
        // Selecionar combinação do pool base
        const shuffled = [...baseNumbers].sort(() => Math.random() - 0.5);
        gameNumbers = shuffled.slice(0, numbersNeeded);
      }
    }
    
    // Ordenar e formatar os números
    gameNumbers.sort((a, b) => a - b);
    const formattedNumbers = gameNumbers.map(num => 
      lotteryType === "lotomania" ? num.toString().padStart(2, '0') : num.toString().padStart(2, '0')
    );
    
    games.push({ numbers: formattedNumbers });
  }

  return games;
};
